export const QueryKeys = {
    GetHistoricalRecords: 'getHistoricalRecords',
    GetHistoricalRecordById: 'getHistoricalRecordById',
    GetHistoricalRecordsFilters: 'getHistoricalRecordsFilters',
    GetEmails: 'getEmails',
    GetEmailTemplateList: 'getEmailTemplateList',
    GetEmailTemplateNotificationTypes: 'getEmailTemplateNotificationTypes',
    GetSMSTemplateList: 'getSMSTemplateList',
    GetSMSTemplateTypes: 'getSMSTemplateTypes',
    GetSMSTemplateById: 'getSMSTemplateById',
    GetSMSHistoricalRecordsFilters: 'getSMSHistoricalRecordsFilters',
    GetSMSHistoricalRecordById: 'getSMSHistoricalRecordById',
    GetChatHistory: 'getChatHistory',
};
export const DATE_FORMAT = 'MM-dd-yyyy';
export const DATE_TIME_FORMAT = 'MM-dd-yyyy hh:mm:ss';
